<template>
  <div>
    <div class="Home">
      Pricing page
    </div>
  </div>
</template>

<script>
export default {
  name: "pricingPage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      products: []
    };
  }
};
</script>
